import { render } from "./ModuleTasks.vue?vue&type=template&id=c30855ba&scoped=true&ts=true"
import script from "./ModuleTasks.vue?vue&type=script&lang=ts"
export * from "./ModuleTasks.vue?vue&type=script&lang=ts"

import "./ModuleTasks.vue?vue&type=style&index=0&id=c30855ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c30855ba"]])

export default __exports__